<script setup lang="ts">
import { useQuoteStore } from "../stores/quotes";
import LoadingBar from "./LoadingBar.vue";

const quoteStore = useQuoteStore();

</script>

<template>
    <LoadingBar
        :number-of-possible-quotes="quoteStore.panelSize"
        :quotations="quoteStore.quotations"
    />
    <div class="warning-box">
        <p class="bold mb-2 loading-title">
            Please note Scottish Widows are unable to return online quotes.
        </p>
        <p>They may be able to provide a higher annuity income than other providers. To get a guaranteed quote from them to compare, please call Annuity Ready.</p>
    </div>
</template>
<style scoped>
.get-quotes-bar{
        position: relative;
        z-index: 2;
    }
    .warning-box {
    max-width: 400px;
    border: 1px solid #000000;
    margin: auto;
    padding: 20px;
}

.loading-title {
    font-weight: 600;
    color: #494949;
    padding-bottom: 20px;
}
</style>
